import React, { FC } from 'react';
import { Icon } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { ISocialAccount } from '@src/types/resumeDetail/socialType';
import './index.scss';

interface IProps {
  data: ISocialAccount[];
  setMode: Function;
}

// 仅社招
const SocialAccountView: FC<IProps> = (props) => {
  const { data, setMode } = props;
  const { socialResumeFormRefStore } = useRootStore();

  const storeRef = socialResumeFormRefStore;

  const handleEdit = () => {
    setMode('edit');
    storeRef.setCurrentScrollRef('social_account_edit');
  };

  // 必须枚举，不然会报错
  const handleIconImg = (param) => {
    if (param === '领英') return require('../../../../../../imgs/lingying.svg');
    if (param === '微博') return require('../../../../../../imgs/weibo.svg');
    if (param === '知乎') return require('../../../../../../imgs/zhihu.svg');
    if (param === 'github') return require('../../../../../../imgs/github.svg');
    if (param === 'csdn') return require('../../../../../../imgs/csdn.svg');
    if (param === '脉脉') return require('../../../../../../imgs/maimai.svg');
    return require('../../../../../../imgs/unknow_social.svg');
  };

  return (
    <div className="social_accounts_view model_view">
      <div className="model_title">
        <div>社交账号</div>
        <div className="edit_icon" onClick={() => handleEdit()}>
          <Icon type="edit-o" style={{ color: '#A9AFB8', fontSize: 22 }} />
        </div>
      </div>
      <div className="model_main">
        {data?.map((item) => (
          <div className="model_list " key={item.renderId}>
            <img
              className="social_accounts_list_img"
              src={handleIconImg(item.name)}
              alt=""
              onClick={() => window.open(item.homePage)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialAccountView;
